import db from "@/database";

export const findAll = () => db.chromosome.toArray();
